export default {"src":"/_next/static/media/new-mail.0fa2179a.svg","height":448,"width":500};